<template>
  <el-select
    v-model="localValue"
    :size="size"
    :multiple="multiple"
    remote
    clearable
    filterable
    :placeholder="placeholder"
    :remote-method="remoteMethod"

    @visible-change="$event ? remoteMethod() : null"
  >
    <div
      v-loading="loading"
      v-infinite-scroll="nextPage"
      :infinite-scroll-immediate="false"
      :infinite-scroll-delay="100"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.full_name"
        :value="item.id"
      >
      </el-option>
    </div>
  </el-select>

</template>

<script>


import {paginator} from "@/mixins/paginator";

export default {
  name: "user-select",
  mixins: [paginator],
  components: {},
  props: {
    value: {},
    size: {type: String, default: ''},
    placeholder: {type: String, default: ''},
    multiple: {type: Boolean, default: true},
    skipPermissions: {type: Boolean, default: false},
    onCurrentNegotiation: {type: Boolean, default: false},
    filters: {type: Object},
  },

  data() {
    return {
      loading: false,
      query: null,
      page: 1,
      options: [],
    }
  },
  mounted() {
    this.remoteMethod()
  },
  watch: {},
  computed: {
    localValue: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        if( !newValue ){
          newValue = null;
        }
        this.selected(newValue)
      }
    }
  },
  methods: {
    remoteMethod(query) {
      this.query = query;
      this.page = 1;
      this.options = [];
      this.getData();
    },

    nextPage(){
      this.page++;
      this.getData();
    },

    getData() {
      if( this.paginator.pageCount && this.page > this.paginator.pageCount ){
        return;
      }
      this.loading = true;
      const filterRole = this.filterRole ? this.filterRole : this.$companyConfiguration.user.getUsersListDefaultRoleFilterInSearch();
      this.$api.user.search({
        ...this.filters,
        roles: filterRole
          ? Array.isArray(filterRole)
            ? filterRole
            : [filterRole]
          : null,
        skip_permissions: this.skipPermissions ? 1 : 0,
        on_current_negotiation: this.onCurrentNegotiation ? 1 : null,
        search: this.query,
        page: this.page
      })
        .then(({data, paginator}) => {
          this.options = this.options.concat(data.users);
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },

    selected(value) {
      this.$emit('input', value);
      this.$emit('selected', value)
    }
  },

}
</script>


<style scoped>

</style>